import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Zoeken',
  },
  searchResults: {
    showMore: 'Toon meer resultaten',
    noResults: 'Helaas, we vonden geen resultaten voor jouw zoekopdracht <b>{storeSearchTerm}</b>',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC® of PEFC',
      ecofriendly: 'Milieuvriendelijke materialen',
      overnight: 'Express en Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Online ontwerpen',
    },
    taglines: {
      home: 'Meer informatie',
      text: 'Meer informatie',
      themes: 'Meer informatie',
      external: 'Meer informatie',
      info: 'Meer informatie',
      category: 'Meer informatie',
      content: 'Meer informatie',
      product: 'Product samenstellen',
    },
    headings: {
      categories: 'Productcategorieën',
      products: 'Producten',
      external: 'Meer informatie',
    },
    slider: {
      previousSlide: 'Toon de vorige inhoud',
      nextSlide: 'Toon de volgende inhoud',
    },
  },
  searchInput: {
    inputTooShortError: 'Uw zoekterm is te kort (min 2)',
    results: 'Resultaten',
    result: 'Resultaat',
    youSearchFor: 'Resultaten voor',
    suggestedTerm: {
      didYouMean: 'Bedoelde je',
      resultsFor: 'Zoek in plaats daarvan naar',
      didYouMeanPostFix: '?',
      resultsForPostFix: '',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Lijstweergave',
      gridButtonTooltip: 'Tegelweergave',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Wis alle filters',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Filters',
        buttonsTooltipLabel: 'Visie',
        resultLabel: 'Zoekresultaten',
      },
      contexts:
        {
          product: 'Product',
          content: 'Diversen',
          all: 'all',
          category: 'Productcategorieën',
          external: 'Meer informatie',
        },
    },
    breadcrumbs: {
      start: 'Begin',
      search: 'Zoeken',
    },
  },
  sideBar: {
    filter: 'Filter',
    filterOverwrite: {
      category: {
        text: 'Inhoud',
      },
      rootCategory: {
        text: 'Inhoud',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'FSC',
          logoPfsc: 'PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Same Day',
          expressAvailable: 'Express',
          overnightAvailable: 'Overnight',
          ecoFriendly: 'Eco Friendly',
          onlineDesign: 'Online ontwerp',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'Uw sessie is verlopen en u dient opnieuw in te loggen. U wordt onmiddellijk doorgestuurd naar de login.',
      server403: 'Het verzoek is niet toegepast omdat er geen geldige verificatiegegevens zijn. Laad de pagina opnieuw of neem contact op met onze klantenservice.',
      default: 'Er is een fout opgetreden op de server. Laad de pagina opnieuw of neem contact op met onze klantenservice.',
    },
    errors: {
      server400: 'Het verzoek was niet correct. Laad de pagina opnieuw of neem contact op met onze klantenservice.',
      server404: '404 Pagina niet gevonden. Ga naar de vorige pagina of neem contact op met onze klantenservice.',
      server500: 'Er is een fout opgetreden op de server. Laad de pagina opnieuw of neem contact op met onze klantenservice',
      server501: 'Er is een fout opgetreden op de server. Laad de pagina opnieuw of neem contact op met onze klantenservice',
      server502: 'Er is een fout opgetreden op de server en u krijgt een ongeldig antwoord. Herlaad de pagina of neem contact op met onze klantenservice',
      server503: 'Er is een fout opgetreden op de server. Herlaad de pagina of neem contact op met onze klantenservice',
      server504: 'Er is een fout opgetreden op de server. Laad de pagina opnieuw of neem contact op met onze klantenservice',
      default: 'De server heeft een probleem met het verzoek. Laad de pagina opnieuw of neem contact op met onze klantenservice',
    },
  },
};
export default translation;
